import { render, staticRenderFns } from "./AccountingLegalAndPhysicalBuilding.vue?vue&type=template&id=461a2180&"
import script from "./AccountingLegalAndPhysicalBuilding.vue?vue&type=script&lang=js&"
export * from "./AccountingLegalAndPhysicalBuilding.vue?vue&type=script&lang=js&"
import style0 from "./AccountingLegalAndPhysicalBuilding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports